export default __webpack_public_path__ + "media/images/ad_landing_page/mobile_logo-e1542ff477a061f84436837782bb108a.svg";